import _ from 'lodash';

export function cdnResize(url = '', width = 60, height = 60) {
  const ext = url.split('.').pop();
  return `${url}_srz_${width}_${height}_85_22_0.50_1.20_0.00_${ext}_srz`;
}

export function getQueryParam(param) {
  param = escapeRegExp(param);
  const regex = new RegExp(`${param}=([a-z0-9-_]+)`, 'i');
  const match = decodeURIComponent(window.location.href).match(regex);
  return (match && match[1]) || '';
}

export function objectToQueryString(obj) {
  return Object.keys(obj).filter(k => obj[k] !== undefined).map(k => `${k}=${obj[k]}`).join('&');
}

export function queryStringToObject(str) {
  const list = str.replace('?', '').split('&'), obj = {};
  list.forEach(v => {
    v = v.split('=');
    if (v[1]) {
      obj[v[0]] = v[1];
    }
  });
  return obj;
}

export function getPageLoadTime() {
  return window.performance && window.performance.timing && window.performance.timing.fetchStart > 0 ?
    (new Date().getTime()) - window.performance.timing.fetchStart : '';
}

export function getPageRenderingTime() {
  return window.performance && window.performance.timing && window.performance.timing.responseEnd > 0 ?
    (new Date().getTime()) - window.performance.timing.responseEnd : '';
}

export function getCategoriesByQuery(categories, query, limit) {
  query = escapeRegExp(query);
  const pattern = new RegExp('^' + query.toLowerCase() + '| ' + query.toLowerCase(), 'i');

  return categories.filter((category) => {
    return category.name.search(pattern) > -1;
  }).slice(0, limit);
}

export function getPopularSearchesByQuery(query, limit) {
  query = escapeRegExp(query);
  const popularSearches = 'html,facebook,video,chat,calendar,form,search,blog,google,paypal,map,login,instagram,pdf,table,twitter,contact,youtube,music,forum,comments,news,pop up,counter,menu,booking,faq,maps,countdown,store,language,adsense,mailchimp,seo,list,comment,member,gallery,newsletter,weather,email,subscribe,shop,popup,book,forms,poll,text,event,rss,download,logo,iframe,upload,slider,events,table master,testimonials,schedule,123,social,google maps,pop,survey,soundcloud,clock,calender,blogger,google drive,google adsense,donate,sign up,slideshow,skype,slide,payment,embed,contador,photo,reviews,log in,agenda,shopify,site booster,hotel,share,live chat,dropbox,quiz,analytics,document,mail,call,linkedin,flash,powr,file,timeline,back to top,form builder,review,feed,games,banner,videos,яндекс,pinterest,mail chimp,link,count,cookie,time,ad,счетчик,pay,google map,ads,excel,ecwid,testimonial,translate,twitter feed,anyfile,pdf viewer,appointment,register,cookies,drive,contact form,calendario,button,etsy,отзывы,hit counter,чат,radio,members,rollover,spotify,like,image,google calendar,mapa,slide show,vcita,метрика,formulario,cart,pop-up,поиск,game,site search,multilingual,amazon,google analytics,reservation,member login,tumblr,feedback,bookings,favicon,mailing list,musica,timer,rsvp,price,wix,password,shoutout,ecommerce,search bar,top,yandex,vote,таблица,itunes,rating,sign in,comentarios,wordpress,membership,social media,code,chart,order,java,scroll,muut,calander,date,pay pal,wix hit counter,wix language menu,yelp,coupon,live,shopping cart,restaurant,eventbrite,audio,phone'.split(',');

  const pattern = new RegExp('^' + query.toLowerCase() + '| ' + query.toLowerCase(), 'i');

  return popularSearches.filter((keyword) => {
    return keyword.search(pattern) > -1;
  }).slice(0, limit);
}

export function verticalToMarket(vertical) {
  const config = {
    'market_2_0_business': ['business', 'beauty-wellness'],
    'market_2_0_store': ['online-store'],
    'market_2_0_music': ['music']
  };

  return _.findKey(config, (verticals) => {
    return _.includes(verticals, vertical);
  });
}

export function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function scrollTopCenter() {
  return document.getElementById('ln-scroll-inner').scrollTop + (document.documentElement.offsetHeight / 2);
}

export function getAlternateLanguages(url) {
  const regex = /\w+\.wix\.com/;

  const lang = ['x-default', 'de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pl', 'pt', 'ru', 'tr', 'nl', 'sv', 'no', 'da', 'hi', 'cs'];

  return lang.map((i) => ({lang: i, url: url.replace(regex, `${i === 'en' || i === 'x-default' ? 'www' : i}.wix.com`)}));
}

/**
 * For Editor iFrame we have to build links with query parameters
 */
export function pickLinkQuery(query, market) {
  const REQUIRED_PARAMS = ['metaSiteId', 'siteId', 'compId', 'eo', 'lang', 'referralInfo', 'referralInfoCategory'];

  return market === 'editor' ? _.pick(query, REQUIRED_PARAMS) : {};
}



// WEBPACK FOOTER //
// ./services/utils.js